import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/base.css'
import './assets/css/index.css'
import {Carousel,CarouselItem,Image,Breadcrumb,
  BreadcrumbItem,Input,Button,Select,Table,
  TableColumn,Pagination,Dialog,Form,
  FormItem,Option,Loading, Message,} from 'element-ui'
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Loading)
Vue.component(Message)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event')) // 预渲染
  },
}).$mount('#app')
